export default __webpack_public_path__ + "static/media/422.167436bf.jpg";